<template>
  <section class="container">
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-7 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <router-link to="/help">
            Help
          </router-link>
          <span class="mr-2 ml-2"> / </span>

          <router-link :to="`/help/${moduleSlug}`">
            {{ moduleName }}
          </router-link>
        </div>
        <div class="col-lg-5 col-md-6 col-sm-6 col-12 alinmov3">
          <BoxSearch />
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <section>
        <div class="row">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
            <div class="card">
              <div class="articles mt-2">
                <span class="date-article">{{
                  formatDate(document.date)
                }}</span>
                <h1 class="title-article ">{{ document.title }}</h1>
                <div v-html="document.content"></div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
            <div class="card pb-3">
              <h2 class="max-title text-left mb-3">Related</h2>

              <CardArticles
                v-if="module"
                size="md"
                :excerpt="true"
                :searchCriteria="{
                  filtering:
                    module === 'RELEASE'
                      ? {
                          app: 'PARTNERS',
                          type: 'RELEASE',
                          status: 'PUBLISHED'
                        }
                      : {
                          app: 'PARTNERS',
                          module: module,
                          status: 'PUBLISHED'
                        },
                  sorting: {
                    sort: 'CREATED_AT',
                    order: 'ASCENDING'
                  },
                  pagination: {
                    limit: 5,
                    page: 1
                  }
                }"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import apps from "../../Commons/Utility/Apps";
import moment from "moment";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";
import CardArticles from "./Components/CardArticles";
import BoxSearch from "./Components/BoxSearch";
import endpoint from "../../Commons/Services";
import { goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "DocumentDetails",
  data() {
    return {
      document: {
        title: "",
        type: "",
        module: "",
        images: [],
        short_description: "",
        slug: "",
        date: moment(),
        content: ""
      },
      image: "",
      moduleSlug: "",
      documentSlug: "",
      module: "",
      moduleName: "",
      modules: [],
      metaTagParams: {
        titlePage: "Help | RhomTrip Suppliers"
      }
    };
  },
  watch: {
    "$route.params": {
      handler: async function(current, old) {
        let params = current;
        this.moduleSlug = params.moduleSlug;
        this.documentSlug = params.documentSlug;
        this.module = this.getModuleBySlug(this.moduleSlug);
        await this.getDocumentByDetails("SUPPLIERS", this.documentSlug);
      },
      deep: true
    }
  },
  async created() {
    this.modules = apps.modules;
    this.moduleSlug = this.$route.params.moduleSlug;
    this.documentSlug = this.$route.params.documentSlug;
    this.module = this.getModuleBySlug(this.moduleSlug);
    await this.getDocumentByDetails("SUPPLIERS", this.documentSlug);

    var bread = [
      {
        text: "Help",
        to: "/help"
      },
      {
        text: this.moduleName,
        active: true
      }
    ];

    this.setItemsBread(bread);
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    async getDocumentByDetails(app, documentSlug) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.documents.services.getDocumentDetails(
          app,
          documentSlug,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let document = data.data;
          this.document.title = document.title;
          this.document.type = document.type;
          this.document.module = document.module;
          this.document.images = document.images;
          this.image =
            this.document.images.length > 0
              ? this.document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png";
          this.document.short_description = document.short_description;
          this.document.date = document.date;
          this.document.slug = document.slug;
          this.document.content = document.content;
          let moduleSlug =
            this.document.type === "RELEASE" ? "RELEASE" : this.document.module;
          this.moduleName = this.getModuleName(moduleSlug);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    getModuleBySlug(slug) {
      if (module === "ACCOUNT") {
        return "account";
      } else if (module === "DRIVERS") {
        return "drivers";
      } else if (module === "AREAS") {
        return "areas";
      } else if (module === "CUSTOMERS") {
        return "customers";
      } else if (module === "DESTINATIONS") {
        return "destinations";
      } else if (module === "GLOBAL") {
        return "global";
      } else if (module === "LOGS") {
        return "logs";
      } else if (module === "PROFILE") {
        return "profile";
      } else if (module === "RATES") {
        return "rates";
      } else if (module === "RESERVATIONS") {
        return "reservations";
      } else if (module === "USERS") {
        return "users";
      } else if (module === "VEHICLES") {
        return "vehicles";
      } else if (module === "SCHEDULE") {
        return "schedule";
      }
    },
    formatDate(date) {
      return moment
        .parseZone(date)
        .utc(true)
        .format("DD-MMM-YYYY");
    },
    getModuleName(module) {
      if (module === "RELEASE") {
        return `Releases`;
      } else {
        let item = this.modules.find(i => i.value === module);
        return item ? item.name : "";
      }
    },
    ...mapMutations(["setItemsBread", "setLoad", "setMetaTags"])
  },
  computed: {
    ...mapGetters(["sesion", "sigout", "metaTags"])
  },
  filters: {},
  components: {
    WSelect: WSelect,
    Swal,
    CardArticles: CardArticles,
    BoxSearch: BoxSearch
  },
  async beforeMount() {
    this.setMetaTags(this.metaTagParams);
  },
  metaInfo() {
    return this.metaTags;
  }
};
</script>
